import {
  TopTenDigestNotificationI,
  TopTenDueNotificationI,
} from "@/lib/types/notification";

/** The due card in one sentence (C-16 S4). */
export const describeTopTenDue = (
  due: TopTenDueNotificationI | undefined
): string => {
  const who = due?.contact_name?.trim();
  const where = due?.account_name?.trim();
  const lead = who && where ? `${who} at ${where}` : who || where || "a lead";

  return `Time to call ${lead}. It's in your Top 10.`;
};

/** The morning digest in one sentence (C-16 S4). */
export const describeTopTenDigest = (
  digest: TopTenDigestNotificationI | undefined
): string => {
  const count = digest?.due_count ?? 0;

  return count === 1
    ? "1 of your Top 10 is due today."
    : `${count} of your Top 10 are due today.`;
};
